import React, { Component, Fragment } from 'react';
import AceEditor from "react-ace";

import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/theme-github";

interface MisFetchRunLogsProps {
    title: string;
    logs?: string;
}

interface MisFetchRunLogsState {
}



export default class MisFetchRunLogs extends Component<MisFetchRunLogsProps, MisFetchRunLogsState> {
    static displayName = MisFetchRunLogs.name;

    constructor(props: MisFetchRunLogsProps) {
        super(props);

        this.state = {
        }
    }
    
    render() {
        
        return (
              <Fragment>
                <div className={"card flex-item--flex-1"}>
                    <div className={"card__header"}>
                        <div className={"card__title"}>{this.props.title}</div>
                    </div>
                    <AceEditor
                        mode="xml"
                        theme={"github"}
                        value={this.props.logs === undefined ? "Loading" : this.props.logs}
                        name="xmlViewer"
                        width="100%"
                        height="500px"
                        wrapEnabled={true}
                        readOnly={true}
                    />
                </div>
            </Fragment>
        );
    }
}
